const EMPTY_RESPONSE = {
  totalChoferes: 0,
  pageSize: 20,
  totalPages: 1,
  currentPage: 1,
  choferes: [],
};

const CHOFERES_HARDCODE = {
  totalChoferes: 4,
  pageSize: 20,
  totalPages: 1,
  currentPage: 1,
  choferes: [
    {
      idChofer: 112,
      nombreChofer: "SEBASTIAN",
    },
    {
      idChofer: 112,
      nombreChofer: "LUCAS",
    },
    {
      idChofer: 112,
      nombreChofer: "PEDRO",
    },
    {
      idChofer: 112,
      nombreChofer: "MATIAS",
    },
  ],
};
const getChoferes = () => {
  const clientelocalStorage = localStorage.getItem("cliente");
  const cliente = clientelocalStorage ? JSON.parse(clientelocalStorage) : null;

  return {
    data: cliente?.idCliente === 3 ? CHOFERES_HARDCODE : EMPTY_RESPONSE,
  };
};

const choferes = {
  getChoferes,
};

export default choferes;
